"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Session = void 0;
const lodash_1 = require("lodash");
var Session;
(function (Session) {
    function toRemoveBasedOnLimit(list, sessionLimit) {
        const sorted = (0, lodash_1.orderBy)(list, 'createdAt', 'desc');
        const sessionsToKeepIndex = sessionLimit - 1;
        const toRemove = sorted.slice(sessionsToKeepIndex);
        return toRemove;
    }
    Session.toRemoveBasedOnLimit = toRemoveBasedOnLimit;
})(Session || (exports.Session = Session = {}));
//# sourceMappingURL=Session.js.map